import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { Link } from 'react-router-dom';
import { api, getListItems } from '../../services/api';
import { useSiteContent, sectionField } from '../../hooks/useSiteContent';

function GalleryInner() {
  const { content } = useSiteContent('gallery');
  const [images, setImages] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');

  const subtitle = sectionField(content, 'section', 'subtitle', 'Explore Us');
  const title = sectionField(content, 'section', 'title', 'A truly exceptional experience');

  useEffect(() => {
    let cancelled = false;
    api.getGallery('page_gallery')
      .then((res) => {
        if (cancelled) return;
        const items = getListItems(res).map((item) => item.image).filter(Boolean);
        setImages(items);
      })
      .catch(() => {
        if (!cancelled) setImages([]);
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => { cancelled = true; };
  }, []);

  if (!loaded || !images.length) {
    return null;
  }

  const openModal = (imageSrc, event) => {
    event.preventDefault();
    setModalImage(imageSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="overflow-hidden space" id="gallery-sec">
      <div className="container-fuild">
        <div className="title-area mb-30 text-center">
          <span className="sub-title">{subtitle}</span>
          <h2 className="sec-title">{title}</h2>
        </div>
        <div className="row g-2 g-md-3 twa-gallery-grid">
          {images.map((src, idx) => (
            <div className="col-6 col-md-4 col-lg-3" key={`${src}-${idx}`}>
              <div className="gallery-box style5">
                <div className="gallery-img global-img">
                  <img src={src} alt={`${title} ${idx + 1}`} />
                  <Link
                    to={src}
                    className="icon-btn popup-image"
                    onClick={(e) => openModal(src, e)}
                  >
                    <i className="fal fa-magnifying-glass-plus" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={modalImage} />
    </div>
  );
}

export default GalleryInner;
